import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { fetch } from '../../service_broker/fetch';
import { resolveRestApi } from '../../router/app-router';
import { logAndCatchError } from '../../utils/rxjs-utils';
import {
  processHeaders,
  getSubmitData,
  getParentContextChangeSet,
  mergeObjectsAndConcatArrays
} from '../../store/state/epics/util';
import Utils from '../../utils/utils';
import type { Config } from '../../service_broker/fetch';
import constants from '../../constants';
import refreshConstants from '../../refresh';

import type { ActionPayload, ReturnedResponseType, ViewRefreshResponse } from './types';

export const getRefreshRouteKeyForEmbedded = (editType: string | undefined, isLocalAction: boolean = false) => {
  if (editType === constants.ACTION) {
    return isLocalAction ? refreshConstants.REFRESH_CASE_DATA : refreshConstants.REFRESH_ASSIGNMENT_DATA;
  }
  return refreshConstants.REFRESH_CASE_VIEW;
};

export const executeRequest = (actionInPayload: ActionPayload) => {
  const { context } = actionInPayload;

  const changeSet = getSubmitData(context);
  let body: Config['body'] = {
    ...changeSet.content,
    contextData: false
  };

  const parentContextChangeSet = getParentContextChangeSet(context);
  if (!Utils.isEmpty(parentContextChangeSet)) {
    body = mergeObjectsAndConcatArrays(parentContextChangeSet, body);
  }
  const routeKey = getRefreshRouteKeyForEmbedded(actionInPayload.editType, actionInPayload.isLocalAction);
  const { restApi, reqType } = resolveRestApi(routeKey, {
    ID:
      !actionInPayload.isLocalAction && actionInPayload.editType === constants.ACTION
        ? actionInPayload.assignmentID
        : actionInPayload.ID,
    actionID: actionInPayload.actionID,
    viewID: actionInPayload.viewID
  });
  let url = restApi;
  if (actionInPayload.editType === constants.ACTION) {
    url += `?operation=${actionInPayload.operationFlag}`;
    body.interestPageActionID = actionInPayload.interestPageActionID;
  }
  body.interestPage = actionInPayload.interestPage;
  return from(
    fetch(
      url,
      {
        method: reqType,
        body,
        headers: actionInPayload.headers
      },
      context
    )
  ).pipe(
    map((response: ViewRefreshResponse) => {
      const chainedObject: ReturnedResponseType = {
        actionInPayload,
        response: response.data,
        headers: processHeaders(response.headers)
      };
      return chainedObject;
    }),
    logAndCatchError(': Error occurred during ajax call : ', context)
  );
};

export default {
  executeRequest
};
